import React, { useState } from 'react';

const CompanyProvidersContainer = ({ companies, onSelectCompany, onAddCompany, onUpdateCompany, onDeleteCompany, onOpenFormModal }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);

  // Filtrar company patners por búsqueda
  const filteredCompanies = companies.filter(company =>
    (company.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (company.email_patner_company || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">Company Patners</h3>
        <button
          onClick={onOpenFormModal}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium transition-colors flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ingresar Company Patner
        </button>
      </div>
      
      {/* Buscador */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Buscar company patner por nombre o email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Tabla de company patners */}
      <div className="flex-1 overflow-auto">
        <table className="min-w-full bg-white">
          <thead className="sticky top-0 bg-gray-100">
            <tr className="text-gray-600 uppercase text-sm leading-normal">
              <th className="py-3 px-4 text-left">Nombre</th>
              <th className="py-3 px-4 text-left">Email</th>
              <th className="py-3 px-4 text-left">Teléfono</th>
              <th className="py-3 px-4 text-left">Unidades</th>
              <th className="py-3 px-4 text-left">% Negocio</th>
              <th className="py-3 px-4 text-center">Métodos Pago</th>
              <th className="py-3 px-4 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 text-sm">
            {filteredCompanies.length === 0 ? (
              <tr>
                <td colSpan="7" className="py-4 text-center text-gray-500">
                  No se encontraron company patners
                </td>
              </tr>
            ) : (
              filteredCompanies.map((company) => (
                <React.Fragment key={company.id}>
                  <tr
                    className="border-b border-gray-200 hover:bg-blue-50 cursor-pointer transition-colors"
                  >
                    <td 
                      className="py-3 px-4 text-left font-medium"
                      onClick={() => onSelectCompany(company.id)}
                    >
                      {company.name}
                    </td>
                    <td 
                      className="py-3 px-4 text-left"
                      onClick={() => onSelectCompany(company.id)}
                    >
                      {company.email_patner_company}
                    </td>
                    <td 
                      className="py-3 px-4 text-left"
                      onClick={() => onSelectCompany(company.id)}
                    >
                      {company.telefono || '-'}
                    </td>
                    <td 
                      className="py-3 px-4 text-left"
                      onClick={() => onSelectCompany(company.id)}
                    >
                      {company.number_unidades || 0}
                    </td>
                    <td 
                      className="py-3 px-4 text-left"
                      onClick={() => onSelectCompany(company.id)}
                    >
                      {company.businness_patners || 0}%
                    </td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex items-center justify-center space-x-1">
                        {company.banco && (
                          <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-medium" title="Datos bancarios completos">
                            🏦 Banco
                          </span>
                        )}                       
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setExpandedRow(expandedRow === company.id ? null : company.id);
                          }}
                          className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs font-medium transition-colors"
                          title="Ver detalles de pago"
                        >
                          {expandedRow === company.id ? '▲' : '▼'}
                        </button>
                      </div>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex items-center justify-center space-x-2">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onUpdateCompany(company.id);
                          }}
                          className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-xs font-medium transition-colors"
                        >
                          Actualizar
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteCompany(company.id);
                          }}
                          className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs font-medium transition-colors"
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                  {/* Fila expandida con detalles de pago */}
                  {expandedRow === company.id && (
                    <tr className="bg-gray-50">
                      <td colSpan="7" className="py-4 px-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {/* Datos Bancarios */}
                          <div className="bg-white p-4 rounded-lg border border-gray-200">
                            <h5 className="font-semibold text-gray-700 mb-3 flex items-center">
                              🏦 Datos Bancarios
                              {company.banco && <span className="ml-2 text-green-600 text-sm">(✓ Completo)</span>}
                            </h5>
                            {company.banco ? (
                              <div className="space-y-2 text-sm">
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Banco:</span>
                                  <span className="text-gray-800">{company.banco}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Nº Cuenta:</span>
                                  <span className="text-gray-800">{company.numero_Cuenta || '-'}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Tipo:</span>
                                  <span className="text-gray-800">{company.tipo_Cuenta || '-'}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Titular:</span>
                                  <span className="text-gray-800">{company.nombre_Titular || '-'}</span>
                                </div>
                              </div>
                            ) : (
                              <p className="text-gray-500 text-sm italic">No hay datos bancarios registrados</p>
                            )}
                          </div>

                          {/* Datos Breve */}
                          <div className="bg-white p-4 rounded-lg border border-gray-200">
                            <h5 className="font-semibold text-gray-700 mb-3 flex items-center">
                              💳 Datos Breve
                              {company.type_LLave && <span className="ml-2 text-blue-600 text-sm">(✓ Completo)</span>}
                            </h5>
                            {company.type_LLave ? (
                              <div className="space-y-2 text-sm">
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Tipo Llave:</span>
                                  <span className="text-gray-800">{company.type_LLave}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Nº Llave:</span>
                                  <span className="text-gray-800">{company.number_LLave || '-'}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Titular:</span>
                                  <span className="text-gray-800">{company.titular_Breve || '-'}</span>
                                </div>
                              </div>
                            ) : (
                              <p className="text-gray-500 text-sm italic">No hay datos breve registrados</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CompanyProvidersContainer;
